import {
  IncentiveCatalogPicker,
  IncentiveCatalogPickerProps,
} from './IncentiveCatalogPicker';

export const IncentiveProductPicker = (props: IncentiveCatalogPickerProps) => (
  <IncentiveCatalogPicker {...props} resource="products" />
);
